import React from 'react';

const ConnectedContext = React.createContext({
    connected: false,
    setConnected: (connected: boolean) => {}
  })

export default ConnectedContext